/* Created by Interactive 63 - https://interactive63.com */
/**
 * Builds the recent-projects thumbnail: the first frame of the compiled scene, as a small SVG
 * data URL. Animations are paused so the image shows the pose at time zero.
 */
import { compileScene } from '../../core/compiler/compile';
import type { Project } from '../../core/model/types';
import { thumbnailFromMarkup } from './project-storage';

const FREEZE_RULE = '*{animation-play-state:paused!important}';

/** Returns a thumbnail data URL for the project, or null if it would be too large. */
export function buildThumbnail(project: Project): string | null {
  const scene = compileScene(project, { target: 'preview', exportSettings: project.export });
  const styled = scene.svgMarkup.replace(
    /^(<svg\b[^>]*>)/,
    `$1<style>${scene.css}${FREEZE_RULE}</style>`,
  );
  return thumbnailFromMarkup(styled);
}
